import ConsentIcon from 'components/icons/ConsentIcon';
import React from 'react';
import LocalizedLink from 'components/LocalizedLink';
import HelpIcon from 'components/icons/HelpIcon';
import MobilePhoneIcon from 'components/icons/MobilePhoneIcon';
import ExternalLink from 'components/organisms/ExternalLink';
import { Translator } from 'Translator';
const CSS = require('./NavbarList.less');

function HelpListItem({ onClick }) {
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <ExternalLink elementType={'a'} className={CSS.MenuItemLink} url="https://support.withlocals.com" openInNewTab={true}>
        {Translator.translate('Navbar.Buttons.help', {}, true, 'Help')}
      </ExternalLink>
      <div className={CSS.IconContainer}>
        <HelpIcon className={CSS.Icon} width={25} height={25} />
      </div>
    </li>
  );
}

function PhoneListItem({ onClick }) {
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <a className={CSS.MenuItemLink} href={'tel:+31202440076'}>
        {Translator.translate('Navbar.Buttons.callUs', { phoneNumber: '' }, true, 'Call us {phoneNumber}')}
        <span className={CSS.PhoneNumber}>+31 20 2440 076</span>
      </a>
      <div className={CSS.IconContainer}>
        <MobilePhoneIcon className={CSS.Icon} width={18} height={30} />
      </div>
    </li>
  );
}

function ConsentListItem({ onClick }) {
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemLink} to={{ pathname: '/consent/', state: { openSettings: true } }}>
        {Translator.translate('Navbar.Buttons.consents', {}, true, 'Consent')}
      </LocalizedLink>
      <div className={CSS.IconContainer}>
        <ConsentIcon className={CSS.Icon}/>
      </div>
    </li>
  );
}

export {
  HelpListItem,
  PhoneListItem,
  ConsentListItem,
};
